exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".YW447G4GyX0mC6TA_bLZG{height:24px}html[dir] .YW447G4GyX0mC6TA_bLZG,html[dir] .YW447G4GyX0mC6TA_bLZG .ms-Callout-main{border-radius:15px}._2VqzV2UzjZRdnkp8_KDInW{display:-webkit-box;display:-ms-flexbox;display:flex}._3WzHXwmtmTr7X4mzRDK3Ff{color:var(--neutralSecondary);font-size:10pt;text-decoration:none}html[dir] ._3WzHXwmtmTr7X4mzRDK3Ff{padding:2px 7px}", ""]);
// Exports
exports.locals = {
	"callout": "YW447G4GyX0mC6TA_bLZG",
	"calloutContainer": "_2VqzV2UzjZRdnkp8_KDInW",
	"calloutText": "_3WzHXwmtmTr7X4mzRDK3Ff"
};